// Briefing prose and chat replies share one mark syntax. Heatmap citations
// and the briefing renderer both walk these; neither should restate the pattern.
export const MARK_RE = /\[\[(team|measure|set|chart|up|down):([^\]]+)\]\]/g;

export function eachMark(text, visit) {
  if (typeof text !== 'string' || text.indexOf('[[') === -1) return;
  const pattern = new RegExp(MARK_RE.source, 'g');
  let match = pattern.exec(text);
  while (match) {
    visit(match);
    match = pattern.exec(text);
  }
}
